<template>
  <header>
    <div class="logo">
      <a href="https://castelatto.com.br">
        <img src="@/assets/new_castelatto.png" alt="Castelatto" width="153" height="22"/>
      </a>
    </div>
    <div class="container-right">
      <div class="lang_sel_list_vertical form-group">
        <select class="form-control mt-3" v-model="language" @change="handlerTranslate">
          <option value="pt">pt-br</option>
          <option value="en">en-us</option>
          <option value="es">es-es</option>
          <option value="it">it-it</option>
        </select>
      </div>
      <div class="btn mt-3">
        <a href="https://castelatto.com.br">Voltar ao site</a>
      </div>
    </div>
  </header>
</template>

<script>
import Events from '../shared/events';

export default {
  name: 'header-component',
  props: {
    msg: String
  },
  data() {
    return {
      language: this.$route.params.language,
    }
  },
  methods: {
    handlerTranslate(event) {
      this.$router.push({ params: { language: event.target.value } });
      Events.$emit('change_translate', event.target.value);
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
header {
  height: 80px;
  width: 100%;
  background: #000;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .container-right {
    display: flex;
    align-items: center;
    min-width: 33.34%;
    padding: 0 15px;
  }
  .lang_sel_list_vertical {
    ul {
      list-style: none;
      display: flex;
      justify-content: space-around;
      li {
        margin-right: 10px;
      }
    }
  }
  .logo {
    margin-left: 60px;
  }
  .btn {
    width: 50%;
    padding: 0 15px;
    margin-left: 20px;
    a {
      width: 100%;
      display: block;
      color: #201D1D;
      font-weight: bold;
      font-size: 13px;
      text-align: center;
      text-transform: uppercase;
      text-decoration: none;
      padding: 0.55rem;
      border-radius: 40px;
    }
  }
  .form-control {
    display: block;
    width: 100%;
    background: #2b2828;
    border-radius: 37px;
    font-size: 12px;
    font-weight: 700;
    height: 29px;
    color: #fff;
    position: relative;
    z-index: 20;
    padding: 0.25rem 0.5rem;
    border: 0;
    box-shadow: 0px 0px 0px 1px #fff;
    &::placeholder {
      color: #fff;
      text-transform: uppercase;
    }
  }
  select.form-control {
    border-right: 10px solid #2b2828;
  }
}

@media screen and (max-width: 970px) {
  .container header {
    flex-direction: column;
    height: auto;
    width: 100%;
    justify-content: center;
    align-items: center;
    .btn {
      margin-left: 0px;
    }
    .mt-3 {
      margin-top: 10px;
    }
    .logo {
      margin: 0;
    }
    .container-right {
      flex-direction: column;
      .lang_sel_list_vertical {
        width: 100%;
      }
      ul {
        padding-left: 0;
        width: 100%;
        justify-content: space-around;
        li {
          margin-right: 0;
        }
      }
      .btn {
        width: 100%;
      }
    }
  }
}
</style>
